/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_StudioInputs */

const en_features_sample_studio = /** @type {(inputs: Features_Sample_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength Studio`)
};

const pl_features_sample_studio = /** @type {(inputs: Features_Sample_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio Siła`)
};

/**
* | output |
* | --- |
* | "Strength Studio" |
*
* @param {Features_Sample_StudioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_studio = /** @type {((inputs?: Features_Sample_StudioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_StudioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_studio(inputs)
	return en_features_sample_studio(inputs)
});